// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function NoContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                (rowContractData.contractLevel === '')
                &&
                <Tooltip
                    enterDelay={1000}
                    title="NoContractAvatar"
                >
                <div>
                </div>
                </Tooltip>}
        </Box>

    )

}
